import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import autoTable from "jspdf-autotable";
import { ICustomer, IInvoiceData, IInvoiceFormData, InvoiceFormExtended, InvoiceItem, IPerformaInvoice } from "../Interfaces/IInvoice";

//Original without decimal
// export function convertINRToWords(input: number | string): string {
//   const singleDigits = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
//   const twoDigits = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
//   const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
//   const placeValues = ["", "Thousand", "Lakh", "Crore"];

//   function numberToWords(n: number): string {
//     if (n === 0) return "";
//     if (n < 10) return singleDigits[n];
//     if (n < 20) return teens[n - 10];
//     if (n < 100) return `${twoDigits[Math.floor(n / 10)]} ${singleDigits[n % 10]}`.trim();
//     if (n < 1000) return `${singleDigits[Math.floor(n / 100)]} Hundred ${numberToWords(n % 100)}`.trim();

//     const parts: string[] = [];
//     let place = 0;

//     while (n > 0) {
//       const chunk = place === 0 ? n % 1000 : n % 100;
//       if (chunk > 0) {
//         const chunkWords = numberToWords(chunk);
//         const placeValue = placeValues[place];
//         parts.unshift(`${chunkWords} ${placeValue}`.trim());
//       }
//       n = Math.floor(place === 0 ? n / 1000 : n / 100);
//       place++;
//     }

//     return parts.join(" ");
//   }

//   // Parse the input to remove leading zeros and handle it as a number
//   const amount = typeof input === "string" ? parseInt(input.replace(/^0+/, ""), 10) : input;
//   if (isNaN(amount)) {
//     return "Invalid input";
//   }

//   const [rupeesPart, paisePart] = amount.toFixed(2).split(".");
//   const rupees = parseInt(rupeesPart, 10);
//   const paise = parseInt(paisePart, 10);

//   let result = "";

//   if (rupees > 0) {
//     result += numberToWords(rupees);
//   }
//   if (paise > 0) {
//     result += ` And ${numberToWords(paise)} Paise`;
//   }

//   return result.trim() + " Only";
// }
const emptyCustomer: ICustomer = {
  id: '',
  name: '',
  email: '',
  phone: '',
  GSTIN: '',
  street: '',
  city: '',
  state: '',
  zipCode: '',
  country: '',
  companyName: '',
};
type TaxSlab = "3" | "5" | "12" | "18" | "28";
//For generate PDF for all type of reports

/**
 * Generates a PDF report with organization details and total sales.
 * @param {string} title - Report title
 * @param {string} orgName - Organization Name
 * @param {string} orgAddress - Organization Address
 * @param {Array} columns - Column headers
 * @param {Array} data - Table data
 * @param {number} totalSales - Total sales amount
 */
export const generatePDFReport = (
  title: string,
  orgName: string,
  orgAddress: string,
  columns: string[],
  data: any[],
  totalSales: number | string
) => {
  const doc = new jsPDF();

  // Organization Header
  doc.setFontSize(16);
  doc.text(orgName, 14, 10);
  doc.setFontSize(10);
  doc.text(orgAddress, 14, 16);

  // Report Title
  doc.setFontSize(14);
  doc.text(title, 14, 26);
  // Table
  autoTable(doc, {
    startY: 35,
    head: [columns],
    body: data,
    theme: "striped",
    styles: { fontSize: 10 },
    headStyles: { fillColor: [22, 160, 133] }, // Custom table header color
  });
  // Dynamically calculate the next position after the table
  const finalY = (doc as any).lastAutoTable.finalY || 80;
  // Total Sales
  if (title != "Sales Report by Item" && title != "Category-wise Stock Report") {
    doc.setFontSize(12);
    doc.text(`Grand Total Rs.${totalSales}`, 14, finalY + 10);
  }
  // Save PDF
  doc.save(`${title}.pdf`);
};

export const sanitizeValue = (value: string | undefined) => {
  return (!value || value === "undefined" || value === "null") ? '' : value;
};
export const indianStates = [
  { label: "Andhra Pradesh", value: "37" },
  { label: "Arunachal Pradesh", value: "12" },
  { label: "Assam", value: "18" },
  { label: "Bihar", value: "10" },
  { label: "Chhattisgarh", value: "22" },
  { label: "Delhi", value: "07" },
  { label: "Goa", value: "30" },
  { label: "Gujarat", value: "24" },
  { label: "Haryana", value: "06" },
  { label: "Himachal Pradesh", value: "02" },
  { label: "Jharkhand", value: "20" },
  { label: "Karnataka", value: "29" },
  { label: "Kerala", value: "32" },
  { label: "Madhya Pradesh", value: "23" },
  { label: "Maharashtra", value: "27" },
  { label: "Manipur", value: "14" },
  { label: "Meghalaya", value: "17" },
  { label: "Mizoram", value: "15" },
  { label: "Nagaland", value: "13" },
  { label: "Odisha", value: "21" },
  { label: "Punjab", value: "03" },
  { label: "Rajasthan", value: "08" },
  { label: "Sikkim", value: "11" },
  { label: "Tamil Nadu", value: "33" },
  { label: "Telangana", value: "36" },
  { label: "Tripura", value: "16" },
  { label: "Uttar Pradesh", value: "09" },
  { label: "Uttarakhand", value: "05" },
  { label: "West Bengal", value: "19" },
  { label: "Ladakh", value: "38" },
  { label: "Lakshadweep", value: "31" },
  { label: "Puducherry", value: "34" },
  { label: "Chandigarh", value: "04" },
  { label: "Andaman and Nicobar Islands", value: "35" },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: "26" },
  { label: "Jammu and Kashmir", value: "01" },
];

//Get GST state code
export const getStateCode = (stateName: any) => {
  const state = indianStates.find((s) => s.label === stateName);
  return state ? state.value : ""; // Returns GST Code or "Not Found"
};
//Generate invoice PDF from GST and New Invoice screen
export const generateBaseInvoicePDF = (orgDetails: any,
  formData: IInvoiceFormData,
  selectedCustomerById: ICustomer | null,
  invoiceItems: InvoiceItem[],
  subTotal: number,
  totalCGST: number,
  totalSGST: number,
  totalGST: number,
  discTotal: number,
  includeShipping: boolean,
  shippingCharge: number,
  total: number,
  isIntraState: boolean,
  buyerStateCode: string,
  sellerStateCode: string,
  taxSummary: Record<TaxSlab, number>,
) => {
  try {
    const doc = new jsPDF();
    //Start LM
    doc.text(`TAX INVOICE`, 85, 8);
    // Draw a single rectangle
    doc.rect(14, 12, 94, 38); // x, y, width, height
    // Set bold font for Organization Name
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(orgDetails?.OrgName || "N/A", 16, 18); // Print Org Name in bold
    // Reset font for Organization Details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    // Full Address String
    const sellerAddress = `Address: ${orgDetails?.address[0]?.addressLine1 || ''}, ${orgDetails?.address[0]?.addressLine2 || ''}, ${orgDetails?.address[0]?.city || ''}, ${orgDetails?.address[0]?.state || ''}, ${orgDetails?.address[0]?.zipCode || ''}`;
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedAddress = doc.splitTextToSize(sellerAddress, 90); // 90 = inner width (94 - margin)

    // Prepare the rest of the lines
    const otherSellerDetails = [
      `E-Mail: ${orgDetails?.email || ""}`,
      `Contact Number: ${orgDetails?.phone || ""}`,
      `GSTIN/UIN: ${orgDetails?.GST || ""}`,
      `State Name: ${orgDetails?.address[0]?.state || ""}, Code:${sellerStateCode || ""}`,
    ];

    // Combine wrapped address with other lines
    const orgDetailsText = [...wrappedAddress, ...otherSellerDetails];
    // Print all lines starting a bit lower after the Org Name
    doc.text(orgDetailsText, 16, 23); // y = 23 to leave space after the Org Name

    // Buyer (Bill To) Section
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Buyer (Bill To)", 16, 53.5);

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    //doc.text(`${selectedCustomerById?.name ?? selectedCustomerById?.companyName}`, 16, 59); // Print Org Name in bold
    const buyerName = selectedCustomerById?.name ?? selectedCustomerById?.companyName ?? "";
    const wrappedBuyerName = doc.splitTextToSize(buyerName, 90); // 90 is max width
    doc.text(wrappedBuyerName, 16, 59);
    // Reset font for buyer details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    // Full Address String
    // const buyerAddress = `${selectedCustomerById?.street || ''}, ${selectedCustomerById?.city || ''}, ${selectedCustomerById?.state || ''}, ${selectedCustomerById?.zipCode || ''},${selectedCustomerById?.phone || ''}`;
    const customerData: ICustomer = selectedCustomerById ?? emptyCustomer;
    const buyerAddressParts = [
      safe(customerData?.street),
      safe(customerData?.city),
      safe(customerData?.state),
      safe(customerData?.zipCode),
      safe(customerData?.phone),
    ];
    const buyerAddress = buyerAddressParts.filter(part => part).join(', ');
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedbuyerAddress = doc.splitTextToSize(buyerAddress, 90); // 90 = inner width (94 - margin)
    const buyerDetailsText = [
      `GSTIN/UIN: ${selectedCustomerById?.GSTIN || ""}`,
      `State Name: ${selectedCustomerById?.state || ""}, Code:${buyerStateCode || ""}`,
    ];
    // Combine wrapped address with other lines
    const buyersDetails = [...wrappedbuyerAddress, ...buyerDetailsText];
    // Draw a rectangle for Buyer details
    // Invoice Details (Right Side)
    const dueDate = new Date(formData.dueDate);
    const invoiceDate = new Date(formData.invoiceDate);
    const orderDateRaw = formData?.buyerOrderDate;
    const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;
    // Format as DD/MM/YYYY
    const formattedDate = dueDate.toLocaleDateString("en-GB");
    const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
    const formattedorderDate = orderDate && !isNaN(orderDate.getTime()) ? orderDate.toLocaleDateString("en-GB") : "";
    doc.rect(14, 50, 94, 42); // x, y, width, height
    //doc.text(buyersDetails, 16, 63);
    const buyerNameHeight = wrappedBuyerName.length * 5;
    const buyerDetailsStartY = 58 + buyerNameHeight;
    doc.text(buyersDetails, 16, buyerDetailsStartY);
    // Invoice Details Table (Right Side)
    autoTable(doc, {
      startY: 12, // Keep it at the same top level
      margin: { left: 108 },
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 1, lineWidth: 0.1, lineColor: [0, 0, 0], textColor: [5, 5, 5] },
      columnStyles: { 0: { cellWidth: 44 }, 1: { cellWidth: 44 } },
      body: [
        [`Invoice No.\n${formData.invoiceNumber}`, `Dated:\n${formattedInvoiceDate}`],
        ["Delivery Note\n", `Mode/Terms Payment:\n${formData?.paymentMode}`],
        ["Reference No. & Date\n", "Other References\n"],
        [`Buyer's Order No.\n${formData?.orderNumber}`, `Dated\n${formattedorderDate || ""}`],
        ["Dispatch Doc No.\n", "Delivery Note Date\n"],
        ["Dispatched Through\n", "Destination\n"],
        [{ content: `Terms of Delivery:\n`, colSpan: 2, styles: { minCellHeight: 16 } }]
      ],
    });
    // Table Header and Content
    const tableColumn = [
      { header: "Sn", dataKey: "sn" },
      { header: "Description", dataKey: "description" },
      { header: "HSN", dataKey: "hsn" },
      { header: "Qty", dataKey: "quantity" },
      { header: "Rate", dataKey: "rate" },
      { header: "Disc %", dataKey: "discount" },
      { header: "Tax %", dataKey: "tax" },
      { header: "Amount", dataKey: "amount" },
    ];
    // Generate table rows from invoice items
    const tableRows = invoiceItems.map((item, index) => ({
      sn: index + 1, // Show only for actual items
      description: item.description?.toString(),
      hsn: item?.hsn?.toString(),
      quantity: item?.quantity?.toString(),
      rate: item.rate?.toString(),
      discount: item?.discount?.toString(),
      tax: item?.tax?.toString(),
      amount: (
        item.quantity *
        item.rate *
        (1 - item.discount / 100) *
        (1 + item.tax / 100)
      )?.toFixed(2)?.toString(),
    }));
    // Ensure the table has at least 10 rows by adding empty rows (without SN)
    const blankRowCount = Math.max(10 - tableRows.length, 0);
    for (let i = 0; i < blankRowCount; i++) {
      tableRows.push({
        sn: null as any, // No numbering for blank rows
        description: "",
        hsn: "",
        quantity: "",
        rate: "",
        discount: "",
        tax: "",
        amount: "",
      });
    }
    // Generate Table
    autoTable(doc, {
      columns: tableColumn,
      body: tableRows,
      startY: 82,
      theme: "grid",
      headStyles: { fillColor: [200, 200, 200], textColor: 0 },
      styles: { fontSize: 9, cellPadding: 1, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: [0, 0, 0], fontStyle: 'bold' },
      columnStyles: {
        sn: { cellWidth: 8 }, // Small width for "Sn"
        quantity: { cellWidth: 13 }, // Small width for "Quantity"
        discount: { cellWidth: 13 }, // Small width for "discount"
        tax: { cellWidth: 13 }, // Small width for "tax"
        rate: { cellWidth: 14 }, // Small width for "rate"
        hsn: { cellWidth: 15 }, // Small width for "hsn"
        amount: { cellWidth: 20 }, // Small width for "amount"
      },
      didParseCell: function (data) {
        const rowIndex = data.row.index;
        const isLastRow = rowIndex === tableRows.length - 1; // Check if it's the last row
        const isBlankRow = !tableRows[rowIndex].description?.trim(); // Check if row is blank

        if (isBlankRow) {
          data.cell.styles.lineWidth = { top: 0, bottom: isLastRow ? 0.1 : 0, left: 0.1, right: 0.1 };
          data.cell.styles.textColor = [255, 255, 255]; // Hide text
          data.cell.styles.fillColor = [255, 255, 255]; // Keep background white
        }
      },
    });
    // Dynamically calculate the next position after the table
    const finalY = (doc as any).lastAutoTable.finalY || 90;

    autoTable(doc, {
      body: [
        [
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0.1 } } }, // sn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // description
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // hsn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // qty
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // rate
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // discount
          {
            content: "Total Amount",
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { right: 1, top: 2 },
            },
          },
          {
            content: `${total.toFixed(2)}`,
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { left: 1, top: 2 },
            },
          },
        ],
      ],
      startY: finalY,
      theme: "plain", // no borders by default
      styles: {
        fontSize: 9,
        textColor: [0, 0, 0],
        cellPadding: 2,
        overflow: "linebreak",
      },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 75 },
        2: { cellWidth: 13 },
        3: { cellWidth: 13 },
        4: { cellWidth: 14 },
        5: { cellWidth: 13 },
        6: { cellWidth: 26 },
        7: { cellWidth: 20 },
      },
    });
    const marginAfterTable = (doc as any).lastAutoTable.finalY + 5 || 90;
    //IGST
    if (isIntraState) {
      // SGST & CGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "1.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "2.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "6%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "9%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "14%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "CGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
             { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(totalGST / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "SGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(totalGST / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    } else {
      // IGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "3%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "12%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "18%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "28%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "IGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["3"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["5"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["12"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["18"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["28"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${totalGST.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    }
    // Calculate page height and width
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const marginLeft = 14;
    const summaryX = 140;
    // Get Y position after last autoTable (tax table)
    let yOffset = (doc as any).lastAutoTable?.finalY + 5 || 90;
    const remainingSpace = pageHeight - yOffset;
    // ---------- Estimate footer height ----------
    const termsText = `Terms and Conditions: ${orgDetails?.termAndCondition || ''}`;
    const wrappedText = doc.splitTextToSize(termsText, pageWidth - 30);
    const termsHeight = wrappedText.length * 4;
    const estimatedFooterHeight =
      20 + // bank details
      20 + // summary
      8 +  // amount in words
      8 +  // terms heading
      termsHeight +
      20;  // signature + buffer
    // ✅ Add new page if space is not enough
    if (remainingSpace < estimatedFooterHeight) {
      doc.addPage();
      yOffset = 40; // reset Y for new page
    }
    // ---------- Left Side: Bank Details ----------
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text("Payment Instructions:", marginLeft, yOffset);
    doc.text(`A/c Holder Name: ${orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A"}`, marginLeft, yOffset + 5);
    doc.text(`Account No.: ${orgDetails?.accountDetails?.[0]?.accountNumber || "N/A"}`, marginLeft, yOffset + 10);
    doc.text(`IFSC: ${orgDetails?.accountDetails?.[0]?.ifscCode || "N/A"}`, marginLeft, yOffset + 15);
    doc.text(`Bank Name: ${orgDetails?.accountDetails?.[0]?.bankName || "N/A"}`, marginLeft, yOffset + 20);

    // ---------- Right Side: Summary ----------
    let summaryY = yOffset;
    // const addText = (text: string, x: number, y: number) => {
    //   doc.text(text, x, y);
    //   return y + 5;
    // };
    const labelX = summaryX;
    const amountX = summaryX + 38;
    const addAlignedText = (label: string, value: number, y: number) => {
      doc.text(label, labelX, y);
      doc.text(`Rs.${value.toFixed(2)}`, amountX, y, { align: "left" });
      return y + 5;
    };
    summaryY = addAlignedText(`Subtotal:`, subTotal, summaryY);
    if (isIntraState) {
      summaryY = addAlignedText(`CGST:`, totalCGST, summaryY);
      summaryY = addAlignedText(`SGST:`, totalSGST, summaryY);
    } else {
      summaryY = addAlignedText(`IGST:`, totalGST, summaryY);
    }
    summaryY = addAlignedText(`Total Disc:`, discTotal || 0, summaryY);
    if (includeShipping && shippingCharge > 0) {
      summaryY = addAlignedText(`Shipping Charge:`, shippingCharge, summaryY);
    }
    summaryY = addAlignedText(`Total:`, total, summaryY);
    // ---------- Amount in Words ----------
    yOffset = Math.max(yOffset + 30, summaryY + 10);
    doc.text(`Amount in words: Rupees ${convertINRToWords(total)}.`, marginLeft, yOffset);
    // ---------- Terms & Conditions ----------
    doc.text(wrappedText, marginLeft, yOffset + 10);
    // ---------- Right-Bottom: Signature ----------
    const signatureY = Math.max(yOffset + 10 + termsHeight + 10, pageHeight - 48);
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(`for ${orgDetails?.OrgName || ""}`, summaryX, signatureY);
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(`Authorised Signatory`, summaryX, signatureY + 10);
    // ---------- Footer ----------
    doc.setFontSize(9);
    doc.text(`This is a Computer Generated Invoice`, pageWidth / 2 - 40, pageHeight - 3);

    // ---------- Page Numbers ----------
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
    }

    // ---------- Save PDF ----------
    doc.save(`Invoice_${formData.invoiceNumber}.pdf`);
  }
  catch (error: any) {
    console.log(error.message);
    throw new Error("Error while generating Invoice PDF." + error.messages);
  }
};

export const generateNewInvoicePDF = (orgDetails: any,
  formData: IInvoiceFormData,
  selectedCustomerById: ICustomer | null,
  invoiceItems: InvoiceItem[],
  subTotal: number,
  totalCGST: number,
  totalSGST: number,
  totalGST: number,
  discTotal: number,
  includeShipping: boolean,
  shippingCharge: number,
  total: number,
  isIntraState: boolean,
  buyerStateCode: string,
  sellerStateCode: string,
  taxSummary: Record<TaxSlab, number>,
  mode: "download" | "print" | "blob" = "download" ,
  roundOff:number, 
): Blob | void => {
  try {
    const doc = new jsPDF();
    //Start LM
    doc.text(`TAX INVOICE`, 85, 8);
    // Draw a single rectangle
    doc.rect(14, 12, 94, 38); // x, y, width, height
    // Set bold font for Organization Name
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(orgDetails?.OrgName || "N/A", 16, 18); // Print Org Name in bold
    // Reset font for Organization Details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    // Full Address String
    const sellerAddress = `Address: ${orgDetails?.address[0]?.addressLine1 || ''}, ${orgDetails?.address[0]?.addressLine2 || ''}, ${orgDetails?.address[0]?.city || ''}, ${orgDetails?.address[0]?.state || ''}, ${orgDetails?.address[0]?.zipCode || ''}`;
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedAddress = doc.splitTextToSize(sellerAddress, 90); // 90 = inner width (94 - margin)

    // Prepare the rest of the lines
    const otherSellerDetails = [
      `E-Mail: ${orgDetails?.email || ""}`,
      `Contact Number: ${orgDetails?.phone || ""}`,
      `GSTIN/UIN: ${orgDetails?.GST || ""}`,
      `State Name: ${orgDetails?.address[0]?.state || ""}, Code:${sellerStateCode || ""}`,
    ];

    // Combine wrapped address with other lines
    const orgDetailsText = [...wrappedAddress, ...otherSellerDetails];
    // Print all lines starting a bit lower after the Org Name
    doc.text(orgDetailsText, 16, 23); // y = 23 to leave space after the Org Name

    // Buyer (Bill To) Section
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Buyer (Bill To)", 16, 53.5);

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    //doc.text(`${selectedCustomerById?.name ?? selectedCustomerById?.companyName}`, 16, 59); // Print Org Name in bold
    const buyerName = selectedCustomerById?.name ?? selectedCustomerById?.companyName ?? "";
    const wrappedBuyerName = doc.splitTextToSize(buyerName, 90); // 90 is max width
    doc.text(wrappedBuyerName, 16, 59);
    // Reset font for buyer details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    // Full Address String
    // const buyerAddress = `${selectedCustomerById?.street || ''}, ${selectedCustomerById?.city || ''}, ${selectedCustomerById?.state || ''}, ${selectedCustomerById?.zipCode || ''},${selectedCustomerById?.phone || ''}`;
    const customerData: ICustomer = selectedCustomerById ?? emptyCustomer;
    const buyerAddressParts = [
      safe(customerData?.street),
      safe(customerData?.city),
      safe(customerData?.state),
      safe(customerData?.zipCode),
      safe(customerData?.phone),
    ];
    const buyerAddress = buyerAddressParts.filter(part => part).join(', ');
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedbuyerAddress = doc.splitTextToSize(buyerAddress, 90); // 90 = inner width (94 - margin)
    const buyerDetailsText = [
      `GSTIN/UIN: ${selectedCustomerById?.GSTIN || ""}`,
      `State Name: ${selectedCustomerById?.state || ""}, Code:${buyerStateCode || ""}`,
    ];
    // Combine wrapped address with other lines
    const buyersDetails = [...wrappedbuyerAddress, ...buyerDetailsText];
    // Draw a rectangle for Buyer details
    // Invoice Details (Right Side)
    const dueDate = new Date(formData.dueDate);
    const invoiceDate = new Date(formData.invoiceDate);
    const orderDateRaw = formData?.buyerOrderDate;
    const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;
    // Format as DD/MM/YYYY
    const formattedDate = dueDate.toLocaleDateString("en-GB");
    const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
    const formattedorderDate = orderDate && !isNaN(orderDate.getTime()) ? orderDate.toLocaleDateString("en-GB") : "";
    doc.rect(14, 50, 94, 42); // x, y, width, height
    //doc.text(buyersDetails, 16, 63);
    const buyerNameHeight = wrappedBuyerName.length * 5;
    const buyerDetailsStartY = 58 + buyerNameHeight;
    doc.text(buyersDetails, 16, buyerDetailsStartY);
    // Invoice Details Table (Right Side)
    autoTable(doc, {
      startY: 12, // Keep it at the same top level
      margin: { left: 108 },
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 1, lineWidth: 0.1, lineColor: [0, 0, 0], textColor: [5, 5, 5] },
      columnStyles: { 0: { cellWidth: 44 }, 1: { cellWidth: 44 } },
      body: [
        [`Invoice No.\n${formData.invoiceNumber}`, `Dated:\n${formattedInvoiceDate}`],
        ["Delivery Note\n", `Mode/Terms Payment:\n${formData?.paymentMode}`],
        ["Reference No. & Date\n", "Other References\n"],
        [`Buyer's Order No.\n${formData?.orderNumber}`, `Dated\n${formattedorderDate || ""}`],
        ["Dispatch Doc No.\n", "Delivery Note Date\n"],
        ["Dispatched Through\n", "Destination\n"],
        [{ content: `Terms of Delivery:\n`, colSpan: 2, styles: { minCellHeight: 16 } }]
      ],
    });
    // Table Header and Content
    const tableColumn = [
      { header: "Sn", dataKey: "sn" },
      { header: "Description", dataKey: "description" },
      { header: "HSN", dataKey: "hsn" },
      { header: "Qty", dataKey: "quantity" },
      { header: "Rate", dataKey: "rate" },
      { header: "Disc %", dataKey: "discount" },
      { header: "Tax %", dataKey: "tax" },
      { header: "Amount", dataKey: "amount" },
    ];
    // Generate table rows from invoice items
    const tableRows = invoiceItems.map((item, index) => ({
      sn: index + 1, // Show only for actual items
      description: item.description?.toString(),
      hsn: item?.hsn?.toString(),
      quantity: item?.quantity?.toString(),
      rate: item.rate?.toString(),
      discount: item?.discount?.toString(),
      tax: item?.tax?.toString(),
      amount: (
        item.quantity *
        item.rate *
        (1 - item.discount / 100) *
        (1 + item.tax / 100)
      )?.toFixed(2)?.toString(),
    }));
    // Ensure the table has at least 10 rows by adding empty rows (without SN)
    const blankRowCount = Math.max(10 - tableRows.length, 0);
    for (let i = 0; i < blankRowCount; i++) {
      tableRows.push({
        sn: null as any, // No numbering for blank rows
        description: "",
        hsn: "",
        quantity: "",
        rate: "",
        discount: "",
        tax: "",
        amount: "",
      });
    }
    // Generate Table
    autoTable(doc, {
      columns: tableColumn,
      body: tableRows,
      startY: 82,
      theme: "grid",
      headStyles: { fillColor: [200, 200, 200], textColor: 0 },
      styles: { fontSize: 9, cellPadding: 1, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: [0, 0, 0], fontStyle: 'bold' },
      columnStyles: {
        sn: { cellWidth: 8 }, // Small width for "Sn"
        quantity: { cellWidth: 13 }, // Small width for "Quantity"
        discount: { cellWidth: 13 }, // Small width for "discount"
        tax: { cellWidth: 13 }, // Small width for "tax"
        rate: { cellWidth: 14 }, // Small width for "rate"
        hsn: { cellWidth: 15 }, // Small width for "hsn"
        amount: { cellWidth: 20 }, // Small width for "amount"
      },
      didParseCell: function (data) {
        const rowIndex = data.row.index;
        const isLastRow = rowIndex === tableRows.length - 1; // Check if it's the last row
        const isBlankRow = !tableRows[rowIndex].description?.trim(); // Check if row is blank

        if (isBlankRow) {
          data.cell.styles.lineWidth = { top: 0, bottom: isLastRow ? 0.1 : 0, left: 0.1, right: 0.1 };
          data.cell.styles.textColor = [255, 255, 255]; // Hide text
          data.cell.styles.fillColor = [255, 255, 255]; // Keep background white
        }
      },
    });
    // Dynamically calculate the next position after the table
    const finalY = (doc as any).lastAutoTable.finalY || 90;

    autoTable(doc, {
      body: [
        [
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0.1 } } }, // sn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // description
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // hsn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // qty
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // rate
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // discount
          {
            content: "Total Amount",
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { right: 1, top: 2 },
            },
          },
          {
            content: `${total.toFixed(2)}`,
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { left: 1, top: 2 },
            },
          },
        ],
      ],
      startY: finalY,
      theme: "plain", // no borders by default
      styles: {
        fontSize: 9,
        textColor: [0, 0, 0],
        cellPadding: 2,
        overflow: "linebreak",
      },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 75 },
        2: { cellWidth: 13 },
        3: { cellWidth: 13 },
        4: { cellWidth: 14 },
        5: { cellWidth: 13 },
        6: { cellWidth: 26 },
        7: { cellWidth: 20 },
      },
    });
    const marginAfterTable = (doc as any).lastAutoTable.finalY + 5 || 90;
    //IGST
    if (isIntraState) {
      // SGST & CGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "1.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "2.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "6%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "9%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "14%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "CGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
             { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(totalGST / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "SGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(totalGST / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    } else {
      // IGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "3%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "12%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "18%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "28%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "IGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["3"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["5"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["12"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["18"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["28"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${totalGST.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    }
    // Calculate page height and width
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const marginLeft = 14;
    const summaryX = 140;
    // Get Y position after last autoTable (tax table)
    let yOffset = (doc as any).lastAutoTable?.finalY + 5 || 90;
    const remainingSpace = pageHeight - yOffset;
    // ---------- Estimate footer height ----------
    const termsText = `Terms and Conditions: ${orgDetails?.termAndCondition || ''}`;
    const wrappedText = doc.splitTextToSize(termsText, pageWidth - 30);
    const termsHeight = wrappedText.length * 4;
    const estimatedFooterHeight =
      20 + // bank details
      20 + // summary
      8 +  // amount in words
      8 +  // terms heading
      termsHeight +
      20;  // signature + buffer
    // ✅ Add new page if space is not enough
    if (remainingSpace < estimatedFooterHeight) {
      doc.addPage();
      yOffset = 40; // reset Y for new page
    }
    // ---------- Left Side: Bank Details ----------
    doc.setFontSize(10);
    doc.setTextColor(0);
    // doc.text("Payment Instructions:", marginLeft, yOffset);
    // doc.text(`A/c Holder Name: ${orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A"}`, marginLeft, yOffset + 5);
    // doc.text(`Account No.: ${orgDetails?.accountDetails?.[0]?.accountNumber || "N/A"}`, marginLeft, yOffset + 10);
    // doc.text(`IFSC: ${orgDetails?.accountDetails?.[0]?.ifscCode || "N/A"}`, marginLeft, yOffset + 15);
    // doc.text(`Bank Name: ${orgDetails?.accountDetails?.[0]?.bankName || "N/A"}`, marginLeft, yOffset + 20);
    const paymentLabelX = marginLeft;
    const paymentColonX = marginLeft + 35;
    const paymentValueX = marginLeft + 40;

    const paymentDetails = [
      [
        "A/c Holder Name",
        orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A",
      ],
      [
        "Account No.",
        orgDetails?.accountDetails?.[0]?.accountNumber || "N/A",
      ],
      [
        "IFSC",
        orgDetails?.accountDetails?.[0]?.ifscCode || "N/A",
      ],
      [
        "Bank Name",
        orgDetails?.accountDetails?.[0]?.bankName || "N/A",
      ],
    ];
    doc.text("Payment Instructions:", marginLeft, yOffset);
    paymentDetails.forEach(([label, value], index) => {
      const y = yOffset + 5 + index * 5;
      doc.text(label, paymentLabelX, y);
      doc.text(":", paymentColonX, y);
      doc.text(value, paymentValueX, y);
    });
    // ---------- Right Side: Summary ----------
    let summaryY = yOffset;
    // const addText = (text: string, x: number, y: number) => {
    //   doc.text(text, x, y);
    //   return y + 5;
    // };
    const labelX = summaryX;
    const amountX = summaryX + 38;
    const addAlignedText = (label: string, value: number, y: number) => {
      doc.text(label, labelX, y);
      doc.text(`Rs.${value.toFixed(2)}`, amountX, y, { align: "left" });
      return y + 5;
    };
    summaryY = addAlignedText(`Subtotal:`, subTotal, summaryY);
    if (isIntraState) {
      summaryY = addAlignedText(`CGST:`, totalCGST, summaryY);
      summaryY = addAlignedText(`SGST:`, totalSGST, summaryY);
    } else {
      summaryY = addAlignedText(`IGST:`, totalGST, summaryY);
    }
    summaryY = addAlignedText(`Total Disc:`, discTotal || 0, summaryY);
    if (includeShipping && shippingCharge > 0) {
      summaryY = addAlignedText(`Shipping Charge:`, shippingCharge, summaryY);
    }
    summaryY = addAlignedText(`Total:`, total, summaryY);
    const roundOffValue = Number(roundOff);
    if (!Number.isNaN(roundOffValue) && roundOffValue !== 0) {
      summaryY = addAlignedText(
        `Round Off:`,
        roundOffValue,
        summaryY
      );
    }
    // ---------- Amount in Words ----------
    yOffset = Math.max(yOffset + 30, summaryY + 10);
    doc.text(`Amount in words: Rupees ${convertINRToWords(total)}.`, marginLeft, yOffset);
    // ---------- Terms & Conditions ----------
    doc.text(wrappedText, marginLeft, yOffset + 10);
    // ---------- Right-Bottom: Signature ----------
    const signatureY = Math.max(yOffset + 10 + termsHeight + 10, pageHeight - 48);
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(`for ${orgDetails?.OrgName || ""}`, summaryX, signatureY);
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(`Authorised Signatory`, summaryX, signatureY + 10);
    // ---------- Footer ----------
    doc.setFontSize(9);
    doc.text(`This is a Computer Generated Invoice`, pageWidth / 2 - 40, pageHeight - 3);

    // ---------- Page Numbers ----------
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
    }

    // ---------- Save PDF ----------
    // ---------- Output based on mode (Step: reuse for Print / Download / WhatsApp) ----------
    if (mode === "blob") {
      return doc.output("blob");
    }
    if (mode === "print") {
      doc.autoPrint();
      const blobUrl = doc.output("bloburl");
      window.open(blobUrl as unknown as string, "_blank");
      return;
    }
    doc.save(`Invoice_${formData.invoiceNumber}.pdf`);
  }
  catch (error: any) {
    console.log(error.message);
    throw new Error("Error while generating Invoice PDF." + error.messages);
  }
};
//Print View Invoice PDF
/*
export const printViewInvoicePDF = (orgDetails: any,
  formData: IInvoiceData,
  customers: ICustomer | null,
  taxSummary: Record<TaxSlab, number>,
) => {
  try {
    const doc = new jsPDF();
    const invoiceHeader = formData.invoiceId?.startsWith("PI")
  ? "PERFORMA INVOICE"
  : "TAX INVOICE";

doc.text(invoiceHeader, 75, 8);
    //doc.text(`TAX INVOICE`, 85, 8);
    // Draw a single rectangle
    doc.rect(14, 12, 94, 38);
    // Set bold font for Organization Name
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(orgDetails?.OrgName || "N/A", 16, 18);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    // Full Address String
    const addressObj = orgDetails?.address?.[0] || {};
    const addressParts = [
      addressObj.addressLine1,
      addressObj.addressLine2,
      addressObj.city,
      addressObj.state,
      addressObj.zipCode,
    ];
    // Filter out undefined, null, and empty strings
    const filteredAddressParts = addressParts.filter(part => !!part?.trim());
    const sellerAddress = `Address: ${filteredAddressParts.join(', ')}`;
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedAddress = doc.splitTextToSize(sellerAddress, 90); // 90 = inner width (94 - margin)
    // Prepare the rest of the lines
    const otherSellerDetails = [
      `E-Mail: ${orgDetails?.email || ""}`,
      `Contact Number: ${orgDetails?.phone || ""}`,
      `GSTIN/UIN: ${orgDetails?.GST || ""}`,
      `State Name: ${orgDetails?.address[0]?.state || ""}, Code:${formData.sellerStateCode || ""}`,
    ];
    // Combine wrapped address with other lines
    const orgDetailsText = [...wrappedAddress, ...otherSellerDetails];
    // Print all lines starting a bit lower after the Org Name
    doc.text(orgDetailsText, 16, 23); // y = 23 to leave space after the Org Name

    // Buyer (Bill To) Section
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Buyer (Bill To)", 16, 53.5);

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`${formData?.customerName}`, 16, 59); // Print Org Name in bold

    // Reset font for buyer details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const customerData: ICustomer = customers ?? emptyCustomer;
    const buyerAddressParts = [
      safe(customerData?.street),
      safe(customerData?.city),
      safe(customerData?.state),
      safe(customerData?.zipCode),
      safe(customerData?.phone),
    ];
    const buyerAddress = buyerAddressParts.filter(part => part).join(', ');
    //const buyerAddress = `${filteredAddressPartsBuyer.join(', ')}`;
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedbuyerAddress = doc.splitTextToSize(buyerAddress, 90); // 90 = inner width (94 - margin)
    // const buyerDetailsText = [
    //   `GSTIN/UIN: ${customers?.GSTIN  || ""}`,
    //   `State Name: ${customers?.state || ""}, Code:${formData?.buyerStateCode || ""}`,
    // ];
    const buyerDetailsText: string[] = [];

    if (safe(customers?.GSTIN)) {
      buyerDetailsText.push(`GSTIN/UIN: ${safe(customers?.GSTIN)}`);
    }

    const state = safe(customers?.state);
    const stateCode = safe(formData?.buyerStateCode);

    if (state || stateCode) {
      buyerDetailsText.push(`State Name: ${state} Code: ${stateCode}`);
    }
    // // Combine wrapped address with other lines
    const buyersDetails = [...wrappedbuyerAddress, ...buyerDetailsText];
    // Draw a rectangle for Buyer details
    // Invoice Details (Right Side)
    const dueDate = new Date(formData.dueDate);
    const invoiceDate = new Date(formData.invoiceDate);
    const orderDateRaw = formData?.orderDate;
    const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;
    // Format as DD/MM/YYYY
    const formattedDate = dueDate.toLocaleDateString("en-GB");
    const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
    const formattedorderDate = orderDate && !isNaN(orderDate.getTime()) ? orderDate.toLocaleDateString("en-GB") : "";
    doc.rect(14, 50, 94, 42); // x, y, width, height
    doc.text(buyersDetails, 16, 63);
    // Invoice Details Table (Right Side)
    autoTable(doc, {
      startY: 12, // Keep it at the same top level
      margin: { left: 108 },
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 1, lineWidth: 0.1, lineColor: [0, 0, 0], textColor: [5, 5, 5] },
      columnStyles: { 0: { cellWidth: 44 }, 1: { cellWidth: 44 } },
      body: [
        [`Invoice No.\n${formData.invoiceId}`, `Dated:\n${formattedInvoiceDate}`],
        ["Delivery Note\n", `Mode/Terms Payment:\n${formData?.paymentMode}`],
        ["Reference No. & Date\n", "Other References\n"],
        [`Buyer's Order No.\n${formData?.orderId}`, `Dated\n${formattedorderDate || ""}`],
        ["Dispatch Doc No.\n", "Delivery Note Date\n"],
        ["Dispatched Through\n", "Destination\n"],
        [{ content: `Terms of Delivery:\n`, colSpan: 2, styles: { minCellHeight: 16 } }]
      ],
    });
    // Save the PDF
    ///End LM
    // Table Header and Content
    const tableColumn = [
      { header: "Sn", dataKey: "sn" },
      { header: "Description", dataKey: "description" },
      { header: "HSN", dataKey: "hsn" },
      { header: "Qty", dataKey: "quantity" },
      { header: "Rate", dataKey: "rate" },
      { header: "Disc %", dataKey: "discount" },
      { header: "Tax %", dataKey: "tax" },
      { header: "Amount", dataKey: "amount" },
    ];
    // Generate table rows from invoice items
    const tableRows = formData.itemDetails.map((item, index) => ({
      sn: index + 1, // Show only for actual items
      description: item?.itemDesc?.toString(),
      hsn: item?.hsn?.toString() ?? '',
      quantity: item?.qty?.toString(),
      rate: item?.price?.toString(),
      discount: item?.discount?.toString(),
      tax: item?.Tax?.toString(),
      amount: (
        item.qty *
        item.price *
        (1 - item.discount / 100) *
        (1 + item.Tax / 100)
      )?.toFixed(2)?.toString(),
    }));


    // Ensure the table has at least 10 rows by adding empty rows (without SN)
    const blankRowCount = Math.max(10 - tableRows.length, 0);
    for (let i = 0; i < blankRowCount; i++) {
      tableRows.push({
        sn: null as any, // No numbering for blank rows
        description: "",
        hsn: "",
        quantity: "",
        rate: "",
        discount: "",
        tax: "",
        amount: "",
      });
    }
    // Generate Table
    autoTable(doc, {
      columns: tableColumn,
      body: tableRows,
      startY: 82,
      theme: "grid",
      headStyles: { fillColor: [200, 200, 200], textColor: 0 },
      styles: { fontSize: 9, cellPadding: 1, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: [10, 10, 10], fontStyle: 'bold' },
      columnStyles: {
        sn: { cellWidth: 8 }, // Small width for "Sn"
        quantity: { cellWidth: 13 }, // Small width for "Quantity"
        discount: { cellWidth: 13 }, // Small width for "discount"
        tax: { cellWidth: 13 }, // Small width for "tax"
        rate: { cellWidth: 14 }, // Small width for "rate"
        hsn: { cellWidth: 15 }, // Small width for "hsn"
        amount: { cellWidth: 20 }, // Small width for "amount"
      },
      didParseCell: function (data) {
        const rowIndex = data.row.index;
        const isLastRow = rowIndex === tableRows.length - 1; // Check if it's the last row
        const isBlankRow = !tableRows[rowIndex].description?.trim(); // Check if row is blank

        if (isBlankRow) {
          data.cell.styles.lineWidth = { top: 0, bottom: isLastRow ? 0.1 : 0, left: 0.1, right: 0.1 };
          data.cell.styles.textColor = [255, 255, 255]; // Hide text
          data.cell.styles.fillColor = [255, 255, 255]; // Keep background white
        }
      },
    });
    // Dynamically calculate the next position after the table
    const finalY = (doc as any).lastAutoTable.finalY || 90;

    autoTable(doc, {
      body: [
        [
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0.1 } } }, // sn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // description
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // hsn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // qty
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // rate
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // discount
          {
            content: "Total Amount",
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { right: 1, top: 2 },
            },
          },
          {
            content: `${formData.grandTotal.toFixed(2)}`,
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { left: 1, top: 2 },
            },
          },
        ],
      ],
      startY: finalY,
      theme: "plain", // no borders by default
      styles: {
        fontSize: 9,
        textColor: [10, 10, 10],
        cellPadding: 2,
        overflow: "linebreak",
      },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 75 },
        2: { cellWidth: 13 },
        3: { cellWidth: 13 },
        4: { cellWidth: 14 },
        5: { cellWidth: 13 },
        6: { cellWidth: 26 },
        7: { cellWidth: 20 },
      },
    });
    const marginAfterTable = (doc as any).lastAutoTable.finalY + 5 || 90;
    //IGST
    if (formData?.isIntraState) {
      // SGST & CGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "1.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "2.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "6%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "9%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "14%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "CGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${formData?.totalCGST.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "SGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${formData?.totalSGST.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [10, 10, 10],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    } else {
      // IGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "3%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "12%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "18%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "28%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "IGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["3"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["5"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["12"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["18"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["28"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${formData?.totalTax.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [10, 10, 10],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    }
    // ✅ Get final Y after tax summary table (CGST/SGST/IGST)
    const footerStartY = (doc as any).lastAutoTable?.finalY || 90;

    // Calculate page height and width
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const marginLeft = 14;
    const summaryX = 140;
    // Get Y position after last autoTable (tax table)
    let yOffset = (doc as any).lastAutoTable?.finalY + 5 || 90;
    const remainingSpace = pageHeight - yOffset;
    // ---------- Estimate footer height ----------
    const termsText = `Terms and Conditions: ${orgDetails?.termAndCondition || ''}`;
    const wrappedText = doc.splitTextToSize(termsText, pageWidth - 30);
    const termsHeight = wrappedText.length * 4;

    // const estimatedFooterHeight =
    //   25 + // bank details
    //   30 + // summary
    //   8 +  // amount in words
    //   8 +  // terms heading
    //   termsHeight +
    //   25;  // signature + buffer

    const estimatedFooterHeight =
      20 + // bank details
      20 + // summary
      8 +  // amount in words
      8 +  // terms heading
      termsHeight +
      20;  // signature + buffer


    // ✅ Add new page if space is not enough
    if (remainingSpace < estimatedFooterHeight) {
      doc.addPage();
      yOffset = 40; // reset Y for new page
    }

    // ---------- Left Side: Bank Details ----------
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text("Payment Instructions:", marginLeft, yOffset);
    doc.text(`A/c Holder Name: ${orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A"}`, marginLeft, yOffset + 5);
    doc.text(`Account No.: ${orgDetails?.accountDetails?.[0]?.accountNumber || "N/A"}`, marginLeft, yOffset + 10);
    doc.text(`IFSC: ${orgDetails?.accountDetails?.[0]?.ifscCode || "N/A"}`, marginLeft, yOffset + 15);
    doc.text(`Bank Name: ${orgDetails?.accountDetails?.[0]?.bankName || "N/A"}`, marginLeft, yOffset + 20);

    // ---------- Right Side: Summary ----------
    let summaryY = yOffset;
    const addText = (text: string, x: number, y: number) => {
      doc.text(text, x, y);
      return y + 5;
    };

    summaryY = addText(`Subtotal: Rs.${formData?.subTotalAmount?.toFixed(2)}`, summaryX, summaryY);
    if (formData?.isIntraState) {
      summaryY = addText(`CGST: Rs.${formData?.totalCGST.toFixed(2)}`, summaryX, summaryY);
      summaryY = addText(`SGST: Rs.${formData?.totalSGST.toFixed(2)}`, summaryX, summaryY);
    } else {
      summaryY = addText(`IGST: Rs.${formData?.totalTax.toFixed(2)}`, summaryX, summaryY);
    }
    summaryY = addText(`Total Disc: Rs.${Number(formData?.totalDiscount)?.toFixed(2)}`, summaryX, summaryY);
    //summaryY = addText(`Shipping Charge: Rs.${formData?.shippingCharge>0 ? formData?.shippingCharge.toFixed(2) : '0'}`, summaryX, summaryY);
    if (formData.shippingCharge > 0) {
      summaryY = addText(`Shipping Charge: Rs.${formData?.shippingCharge.toFixed(2)}`, summaryX, summaryY);
    }
    summaryY = addText(`Total: Rs.${formData?.grandTotal.toFixed(2)}`, summaryX, summaryY);

    // ---------- Amount in Words ----------
    yOffset = Math.max(yOffset + 30, summaryY + 10);
    doc.text(`Amount in words: Rupees ${convertINRToWords(formData?.grandTotal)}.`, marginLeft, yOffset);

    // ---------- Terms & Conditions ----------
    doc.text(wrappedText, marginLeft, yOffset + 10);

    // ---------- Right-Bottom: Signature ----------
    const signatureY = Math.max(yOffset + 10 + termsHeight + 10, pageHeight - 48);
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(`for ${orgDetails?.OrgName || ""}`, summaryX, signatureY);

    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(`Authorised Signatory`, summaryX, signatureY + 10);

    // ---------- Footer ----------
    doc.setFontSize(9);
    doc.text(`This is a Computer Generated Invoice`, pageWidth / 2 - 40, pageHeight - 3);

    // ---------- Page Numbers ----------
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
    }

    // ---------- Save PDF ----------
    doc.save(`Invoice_${formData.invoiceId}.pdf`);

  }
  catch (error: any) {
    console.log(error.message);
    throw new Error("Error while generating Invoice PDF." + error.messages);

    // Swal.fire({
    //   icon: "error",
    //   title: "Error",
    //   text: `Failed to save invoice: ${error.message}`,
    // });

  }
};
*/
export const printViewInvoicePDF = (
  orgDetails: any,
  formData: IInvoiceData,
  customers: ICustomer | null,
  taxSummary: Record<TaxSlab, number>,
  action: "download" | "print" | "blob" = "download"
): Blob | void => {
  try {
    const doc = new jsPDF();
    const invoiceHeader = formData.invoiceId?.startsWith("PI")
      ? "PERFORMA INVOICE"
      : "TAX INVOICE";
 
    doc.text(invoiceHeader, 75, 8);
    doc.rect(14, 12, 94, 38);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(orgDetails?.OrgName || "N/A", 16, 18);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const addressObj = orgDetails?.address?.[0] || {};
    const addressParts = [
      addressObj.addressLine1,
      addressObj.addressLine2,
      addressObj.city,
      addressObj.state,
      addressObj.zipCode,
    ];
    const filteredAddressParts = addressParts.filter((part) => !!part?.trim());
    const sellerAddress = `Address: ${filteredAddressParts.join(", ")}`;
    const wrappedAddress = doc.splitTextToSize(sellerAddress, 90);
    const otherSellerDetails = [
      `E-Mail: ${orgDetails?.email || ""}`,
      `Contact Number: ${orgDetails?.phone || ""}`,
      `GSTIN/UIN: ${orgDetails?.GST || ""}`,
      `State Name: ${orgDetails?.address[0]?.state || ""}, Code:${formData.sellerStateCode || ""}`,
    ];
    const orgDetailsText = [...wrappedAddress, ...otherSellerDetails];
    doc.text(orgDetailsText, 16, 23);
 
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Buyer (Bill To)", 16, 53.5);
 
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    //doc.text(`${formData?.customerName}`, 16, 59);
    const buyerName = formData?.customerName;
    const wrappedBuyerName = doc.splitTextToSize(buyerName, 90); // 90 is max width
    doc.text(wrappedBuyerName, 16, 59);
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const customerData: ICustomer = customers ?? emptyCustomer;
    const buyerAddressParts = [
      safe(customerData?.street),
      safe(customerData?.city),
      safe(customerData?.state),
      safe(customerData?.zipCode),
      safe(customerData?.phone),
    ];
    const buyerAddress = buyerAddressParts.filter((part) => part).join(", ");
    const wrappedbuyerAddress = doc.splitTextToSize(buyerAddress, 90);
    const buyerDetailsText: string[] = [];
 
    if (safe(customers?.GSTIN)) {
      buyerDetailsText.push(`GSTIN/UIN: ${safe(customers?.GSTIN)}`);
    }
 
    const state = safe(customers?.state);
    const stateCode = safe(formData?.buyerStateCode);
 
    if (state || stateCode) {
      buyerDetailsText.push(`State Name: ${state} Code: ${stateCode}`);
    }
    const buyersDetails = [...wrappedbuyerAddress, ...buyerDetailsText];
    const dueDate = new Date(formData.dueDate);
    const invoiceDate = new Date(formData.invoiceDate);
    const orderDateRaw = formData?.orderDate;
    const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;
    const formattedDate = dueDate.toLocaleDateString("en-GB");
    const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
    const formattedorderDate =
      orderDate && !isNaN(orderDate.getTime()) ? orderDate.toLocaleDateString("en-GB") : "";
    doc.rect(14, 50, 94, 42);
    const buyerNameHeight = wrappedBuyerName.length * 5;
    const buyerDetailsStartY = 58 + buyerNameHeight;
    doc.text(buyersDetails, 16, buyerDetailsStartY);
    //doc.text(buyersDetails, 16, 63);
    autoTable(doc, {
      startY: 12,
      margin: { left: 108 },
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 1, lineWidth: 0.1, lineColor: [0, 0, 0], textColor: [5, 5, 5] },
      columnStyles: { 0: { cellWidth: 44 }, 1: { cellWidth: 44 } },
      body: [
        [`Invoice No.\n${formData.invoiceId}`, `Dated:\n${formattedInvoiceDate}`],
        ["Delivery Note\n", `Mode/Terms Payment:\n${formData?.paymentMode}`],
        ["Reference No. & Date\n", "Other References\n"],
        [`Buyer's Order No.\n${formData?.orderId}`, `Dated\n${formattedorderDate || ""}`],
        ["Dispatch Doc No.\n", "Delivery Note Date\n"],
        ["Dispatched Through\n", "Destination\n"],
        [{ content: `Terms of Delivery:\n`, colSpan: 2, styles: { minCellHeight: 16 } }],
      ],
    });
 
    const tableColumn = [
      { header: "Sn", dataKey: "sn" },
      { header: "Description", dataKey: "description" },
      { header: "HSN", dataKey: "hsn" },
      { header: "Qty", dataKey: "quantity" },
      { header: "Rate", dataKey: "rate" },
      { header: "Disc %", dataKey: "discount" },
      { header: "Tax %", dataKey: "tax" },
      { header: "Amount", dataKey: "amount" },
    ];
    const tableRows = formData.itemDetails.map((item, index) => ({
      sn: index + 1,
      description: item?.itemDesc?.toString(),
      hsn: item?.hsn?.toString() ?? "",
      quantity: item?.qty?.toString(),
      rate: item?.price?.toString(),
      discount: item?.discount?.toString(),
      tax: item?.Tax?.toString(),
      amount: (item.qty * item.price * (1 - item.discount / 100) * (1 + item.Tax / 100))
        ?.toFixed(2)
        ?.toString(),
    }));
 
    const blankRowCount = Math.max(10 - tableRows.length, 0);
    for (let i = 0; i < blankRowCount; i++) {
      tableRows.push({
        sn: null as any,
        description: "",
        hsn: "",
        quantity: "",
        rate: "",
        discount: "",
        tax: "",
        amount: "",
      });
    }
    autoTable(doc, {
      columns: tableColumn,
      body: tableRows,
      startY: 82,
      theme: "grid",
      headStyles: { fillColor: [200, 200, 200], textColor: 0 },
      styles: { fontSize: 9, cellPadding: 1, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: [10, 10, 10], fontStyle: "bold" },
      columnStyles: {
        sn: { cellWidth: 8 },
        quantity: { cellWidth: 13 },
        discount: { cellWidth: 13 },
        tax: { cellWidth: 13 },
        rate: { cellWidth: 14 },
        hsn: { cellWidth: 15 },
        amount: { cellWidth: 20 },
      },
      didParseCell: function (data) {
        const rowIndex = data.row.index;
        const isLastRow = rowIndex === tableRows.length - 1;
        const isBlankRow = !tableRows[rowIndex].description?.trim();
        if (isBlankRow) {
          data.cell.styles.lineWidth = { top: 0, bottom: isLastRow ? 0.1 : 0, left: 0.1, right: 0.1 };
          data.cell.styles.textColor = [255, 255, 255];
          data.cell.styles.fillColor = [255, 255, 255];
        }
      },
    });
    const finalY = (doc as any).lastAutoTable.finalY || 90;
 
    autoTable(doc, {
      body: [
        [
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0.1 } } },
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } },
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } },
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } },
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } },
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } },
          {
            content: "Total Amount",
            styles: { fontStyle: "bold", halign: "left", lineWidth: 0.1, lineColor: [0, 0, 0], cellPadding: { right: 1, top: 2 } },
          },
          {
            content: `${formData.grandTotal.toFixed(2)}`,
            styles: { fontStyle: "bold", halign: "left", lineWidth: 0.1, lineColor: [0, 0, 0], cellPadding: { left: 1, top: 2 } },
          },
        ],
      ],
      startY: finalY,
      theme: "plain",
      styles: { fontSize: 9, textColor: [10, 10, 10], cellPadding: 2, overflow: "linebreak" },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 75 },
        2: { cellWidth: 13 },
        3: { cellWidth: 13 },
        4: { cellWidth: 14 },
        5: { cellWidth: 13 },
        6: { cellWidth: 26 },
        7: { cellWidth: 20 },
      },
    });
    const marginAfterTable = (doc as any).lastAutoTable.finalY + 5 || 90;
 
    if (formData?.isIntraState) {
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "1.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "2.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "6%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "9%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "14%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "CGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${formData?.totalCGST.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "SGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${formData?.totalSGST.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: { fontSize: 9, textColor: [10, 10, 10], cellPadding: 2, overflow: "linebreak" },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    } else {
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "3%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "12%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "18%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "28%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "IGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["3"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["5"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["12"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["18"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["28"].toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${formData?.totalTax.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: { fontSize: 9, textColor: [10, 10, 10], cellPadding: 2, overflow: "linebreak" },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    }
 
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const marginLeft = 14;
    const summaryX = 140;
    let yOffset = (doc as any).lastAutoTable?.finalY + 5 || 90;
    const remainingSpace = pageHeight - yOffset;
    const termsText = `Terms and Conditions: ${orgDetails?.termAndCondition || ""}`;
    const wrappedText = doc.splitTextToSize(termsText, pageWidth - 30);
    const termsHeight = wrappedText.length * 4;
 
    const estimatedFooterHeight = 20 + 20 + 8 + 8 + termsHeight + 20;
 
    if (remainingSpace < estimatedFooterHeight) {
      doc.addPage();
      yOffset = 40;
    }
 
    doc.setFontSize(10);
    doc.setTextColor(0);
    // doc.text("Payment Instructions:", marginLeft, yOffset);
    // doc.text(`A/c Holder Name: ${orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A"}`, marginLeft, yOffset + 5);
    // doc.text(`Account No.: ${orgDetails?.accountDetails?.[0]?.accountNumber || "N/A"}`, marginLeft, yOffset + 10);
    // doc.text(`IFSC: ${orgDetails?.accountDetails?.[0]?.ifscCode || "N/A"}`, marginLeft, yOffset + 15);
    // doc.text(`Bank Name: ${orgDetails?.accountDetails?.[0]?.bankName || "N/A"}`, marginLeft, yOffset + 20);
    const paymentLabelX = marginLeft;
    const paymentColonX = marginLeft + 35;
    const paymentValueX = marginLeft + 40;

    const paymentDetails = [
      [
        "A/c Holder Name",
        orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A",
      ],
      [
        "Account No.",
        orgDetails?.accountDetails?.[0]?.accountNumber || "N/A",
      ],
      [
        "IFSC",
        orgDetails?.accountDetails?.[0]?.ifscCode || "N/A",
      ],
      [
        "Bank Name",
        orgDetails?.accountDetails?.[0]?.bankName || "N/A",
      ],
    ];
    doc.text("Payment Instructions:", marginLeft, yOffset);
    paymentDetails.forEach(([label, value], index) => {
      const y = yOffset + 5 + index * 5;
      doc.text(label, paymentLabelX, y);
      doc.text(":", paymentColonX, y);
      doc.text(value, paymentValueX, y);
    });
    let summaryY = yOffset;
    const addText = (text: string, x: number, y: number) => {
      doc.text(text, x, y);
      return y + 5;
    };
 
    summaryY = addText(`Subtotal: Rs.${formData?.subTotalAmount?.toFixed(2)}`, summaryX, summaryY);
    if (formData?.isIntraState) {
      summaryY = addText(`CGST: Rs.${formData?.totalCGST.toFixed(2)}`, summaryX, summaryY);
      summaryY = addText(`SGST: Rs.${formData?.totalSGST.toFixed(2)}`, summaryX, summaryY);
    } else {
      summaryY = addText(`IGST: Rs.${formData?.totalTax.toFixed(2)}`, summaryX, summaryY);
    }
    summaryY = addText(`Total Disc: Rs.${Number(formData?.totalDiscount)?.toFixed(2)}`, summaryX, summaryY);
    if (formData.shippingCharge > 0) {
      summaryY = addText(`Shipping Charge: Rs.${formData?.shippingCharge.toFixed(2)}`, summaryX, summaryY);
    }
    summaryY = addText(`Total: Rs.${formData?.grandTotal.toFixed(2)}`, summaryX, summaryY);

    const roundOffValue = Number(formData?.roundOff || 0);
    if (roundOffValue !== 0) {
    summaryY = addText(`Round Off: Rs.${roundOffValue?.toFixed(2)}`, summaryX, summaryY);
    }
    yOffset = Math.max(yOffset + 30, summaryY + 10);
    doc.text(`Amount in words: Rupees ${convertINRToWords(formData?.grandTotal)}.`, marginLeft, yOffset);
 
    doc.text(wrappedText, marginLeft, yOffset + 10);
 
    const signatureY = Math.max(yOffset + 10 + termsHeight + 10, pageHeight - 48);
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(`for ${orgDetails?.OrgName || ""}`, summaryX, signatureY);
 
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(`Authorised Signatory`, summaryX, signatureY + 10);
 
    doc.setFontSize(9);
    doc.text(`This is a Computer Generated Invoice`, pageWidth / 2 - 40, pageHeight - 3);
 
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
    }
 
    // ─── THE FIX: branch on `action` instead of always saving ────────────
    const fileName = `Invoice_${formData.invoiceId}.pdf`;
 
    if (action === "print") {
      // Opens the PDF in a new tab and asks the viewer to invoke print.
      // Chrome/Edge's built-in PDF viewer honors this; the user sees the
      // native print dialog instead of a downloaded file.
      doc.autoPrint();
      const blobUrl = doc.output("bloburl");
      window.open(blobUrl as unknown as string, "_blank");
      return;
    }
 
    if (action === "blob") {
      return doc.output("blob");
    }
 
    // default: "download"
    doc.save(fileName);
    return;
  } catch (error: any) {
    console.log(error.message);
    throw new Error("Error while generating Invoice PDF." + error.messages);
  }
};
//Generate invoice PDF from GST and New Invoice screen
export const generatePerformaInvoicePDF = (orgDetails: any,
  formData: IPerformaInvoice,
  invoiceItems: InvoiceItem[],
  subTotal: number,
  totalCGST: number,
  totalSGST: number,
  totalGST: number,
  discTotal: number,
  includeShipping: boolean,
  shippingCharge: number,
  total: number,
  isIntraState: boolean,
  buyerStateCode: string,
  sellerStateCode: string,
  taxSummary: Record<TaxSlab, number>,
) => {
  try {
    const doc = new jsPDF();
    //Start LM
    doc.text(`PERFORMA INVOICE`, 85, 8);
    // Draw a single rectangle
    doc.rect(14, 12, 94, 38); // x, y, width, height
    // Set bold font for Organization Name
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(orgDetails?.OrgName || "N/A", 16, 18); // Print Org Name in bold
    // Reset font for Organization Details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    // Full Address String
    const sellerAddress = `Address: ${orgDetails?.address[0]?.addressLine1 || ''}, ${orgDetails?.address[0]?.addressLine2 || ''}, ${orgDetails?.address[0]?.city || ''}, ${orgDetails?.address[0]?.state || ''}, ${orgDetails?.address[0]?.zipCode || ''}`;
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedAddress = doc.splitTextToSize(sellerAddress, 90); // 90 = inner width (94 - margin)

    // Prepare the rest of the lines
    const otherSellerDetails = [
      `E-Mail: ${orgDetails?.email || ""}`,
      `Contact Number: ${orgDetails?.phone || ""}`,
      `GSTIN/UIN: ${orgDetails?.GST || ""}`,
      `State Name: ${orgDetails?.address[0]?.state || ""}, Code:${sellerStateCode || ""}`,
    ];

    // Combine wrapped address with other lines
    const orgDetailsText = [...wrappedAddress, ...otherSellerDetails];
    // Print all lines starting a bit lower after the Org Name
    doc.text(orgDetailsText, 16, 23); // y = 23 to leave space after the Org Name

    // Buyer (Bill To) Section
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Buyer (Bill To)", 16, 53.5);

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    //doc.text(`${selectedCustomerById?.name ?? selectedCustomerById?.companyName}`, 16, 59); // Print Org Name in bold
    const buyerName = formData.customerName ?? "";
    const wrappedBuyerName = doc.splitTextToSize(buyerName, 90); // 90 is max width
    doc.text(wrappedBuyerName, 16, 59);
    // Reset font for buyer details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    // Full Address String
    // const buyerAddress = `${selectedCustomerById?.street || ''}, ${selectedCustomerById?.city || ''}, ${selectedCustomerById?.state || ''}, ${selectedCustomerById?.zipCode || ''},${selectedCustomerById?.phone || ''}`;
    // const customerData: ICustomer = selectedCustomerById ?? emptyCustomer;
    // const buyerAddressParts = [
    //   safe(customerData?.street),
    //   safe(customerData?.city),
    //   safe(customerData?.state),
    //   safe(customerData?.zipCode),
    //   safe(customerData?.phone),
    // ];
    // const buyerAddress = buyerAddressParts.filter(part => part).join(', ');
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    //const wrappedbuyerAddress = doc.splitTextToSize(buyerAddress, 90); // 90 = inner width (94 - margin)
    const buyerDetailsText = [
      `Contact Number: ${formData?.contactNumber || ""}`,
      `State Name: ${formData?.customerState || ""}, Code:${buyerStateCode || ""}`,
    ];
    // Combine wrapped address with other lines
    const buyersDetails = ["", ...buyerDetailsText];
    // Draw a rectangle for Buyer details
    // Invoice Details (Right Side)
    const dueDate = new Date(formData.dueDate);
    const invoiceDate = new Date(formData.invoiceDate);
    const orderDateRaw = formData?.buyerOrderDate;
    const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;
    // Format as DD/MM/YYYY
    const formattedDate = dueDate.toLocaleDateString("en-GB");
    const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
    const formattedorderDate = orderDate && !isNaN(orderDate.getTime()) ? orderDate.toLocaleDateString("en-GB") : "";
    doc.rect(14, 50, 94, 42); // x, y, width, height
    //doc.text(buyersDetails, 16, 63);
    const buyerNameHeight = wrappedBuyerName.length * 5;
    const buyerDetailsStartY = 58 + buyerNameHeight;
    doc.text(buyersDetails, 16, buyerDetailsStartY);
    // Invoice Details Table (Right Side)
    autoTable(doc, {
      startY: 12, // Keep it at the same top level
      margin: { left: 108 },
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 1, lineWidth: 0.1, lineColor: [0, 0, 0], textColor: [5, 5, 5] },
      columnStyles: { 0: { cellWidth: 44 }, 1: { cellWidth: 44 } },
      body: [
        [`Proforma Invoice No.\n${formData.invoiceNumber}`, `Dated:\n${formattedInvoiceDate}`],
        ["Delivery Note\n", `Mode/Terms Payment:\n${formData?.paymentMode}`],
        ["Reference No. & Date\n", "Other References\n"],
        [`Buyer's Order No.\n${formData?.orderNumber}`, `Dated\n${formattedorderDate || ""}`],
        ["Dispatch Doc No.\n", "Delivery Note Date\n"],
        ["Dispatched Through\n", "Destination\n"],
        [{ content: `Terms of Delivery:\n`, colSpan: 2, styles: { minCellHeight: 16 } }]
      ],
    });
    // Table Header and Content
    const tableColumn = [
      { header: "Sn", dataKey: "sn" },
      { header: "Description", dataKey: "description" },
      { header: "HSN", dataKey: "hsn" },
      { header: "Qty", dataKey: "quantity" },
      { header: "Rate", dataKey: "rate" },
      { header: "Disc %", dataKey: "discount" },
      { header: "Tax %", dataKey: "tax" },
      { header: "Amount", dataKey: "amount" },
    ];
    // Generate table rows from invoice items
    const tableRows = invoiceItems.map((item, index) => ({
      sn: index + 1, // Show only for actual items
      description: item.description?.toString(),
      hsn: item?.hsn?.toString(),
      quantity: item?.quantity?.toString(),
      rate: item.rate?.toString(),
      discount: item?.discount?.toString(),
      tax: item?.tax?.toString(),
      amount: (
        item.quantity *
        item.rate *
        (1 - item.discount / 100) *
        (1 + item.tax / 100)
      )?.toFixed(2)?.toString(),
    }));
    // Ensure the table has at least 10 rows by adding empty rows (without SN)
    const blankRowCount = Math.max(10 - tableRows.length, 0);
    for (let i = 0; i < blankRowCount; i++) {
      tableRows.push({
        sn: null as any, // No numbering for blank rows
        description: "",
        hsn: "",
        quantity: "",
        rate: "",
        discount: "",
        tax: "",
        amount: "",
      });
    }
    // Generate Table
    autoTable(doc, {
      columns: tableColumn,
      body: tableRows,
      startY: 82,
      theme: "grid",
      headStyles: { fillColor: [200, 200, 200], textColor: 0 },
      styles: { fontSize: 9, cellPadding: 1, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: [0, 0, 0], fontStyle: 'bold' },
      columnStyles: {
        sn: { cellWidth: 8 }, // Small width for "Sn"
        quantity: { cellWidth: 13 }, // Small width for "Quantity"
        discount: { cellWidth: 13 }, // Small width for "discount"
        tax: { cellWidth: 13 }, // Small width for "tax"
        rate: { cellWidth: 14 }, // Small width for "rate"
        hsn: { cellWidth: 15 }, // Small width for "hsn"
        amount: { cellWidth: 20 }, // Small width for "amount"
      },
      didParseCell: function (data) {
        const rowIndex = data.row.index;
        const isLastRow = rowIndex === tableRows.length - 1; // Check if it's the last row
        const isBlankRow = !tableRows[rowIndex].description?.trim(); // Check if row is blank

        if (isBlankRow) {
          data.cell.styles.lineWidth = { top: 0, bottom: isLastRow ? 0.1 : 0, left: 0.1, right: 0.1 };
          data.cell.styles.textColor = [255, 255, 255]; // Hide text
          data.cell.styles.fillColor = [255, 255, 255]; // Keep background white
        }
      },
    });
    // Dynamically calculate the next position after the table
    const finalY = (doc as any).lastAutoTable.finalY || 90;

    autoTable(doc, {
      body: [
        [
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0.1 } } }, // sn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // description
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // hsn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // qty
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // rate
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // discount
          {
            content: "Total Amount",
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { right: 1, top: 2 },
            },
          },
          {
            content: `${total.toFixed(2)}`,
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { left: 1, top: 2 },
            },
          },
        ],
      ],
      startY: finalY,
      theme: "plain", // no borders by default
      styles: {
        fontSize: 9,
        textColor: [0, 0, 0],
        cellPadding: 2,
        overflow: "linebreak",
      },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 75 },
        2: { cellWidth: 13 },
        3: { cellWidth: 13 },
        4: { cellWidth: 14 },
        5: { cellWidth: 13 },
        6: { cellWidth: 26 },
        7: { cellWidth: 20 },
      },
    });
    const marginAfterTable = (doc as any).lastAutoTable.finalY + 5 || 90;
    //IGST
    if (isIntraState) {
      // SGST & CGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "1.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "2.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "6%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "9%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "14%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "CGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(totalGST / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "SGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["3"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["5"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["12"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["18"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(taxSummary["28"] / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${(totalGST / 2).toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    } else {
      // IGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "3%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "12%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "18%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "28%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "IGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["3"]}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["5"]}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["12"]}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["18"]}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${taxSummary["28"]}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${totalGST.toFixed(2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 14 },
          6: { cellWidth: 16 },
        },
      });
    }
    // Calculate page height and width
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const marginLeft = 14;
    const summaryX = 140;
    // Get Y position after last autoTable (tax table)
    let yOffset = (doc as any).lastAutoTable?.finalY + 5 || 90;
    const remainingSpace = pageHeight - yOffset;
    // ---------- Estimate footer height ----------
    const termsText = `Terms and Conditions: ${orgDetails?.termAndCondition || ''}`;
    const wrappedText = doc.splitTextToSize(termsText, pageWidth - 30);
    const termsHeight = wrappedText.length * 4;
    const estimatedFooterHeight =
      20 + // bank details
      20 + // summary
      8 +  // amount in words
      8 +  // terms heading
      termsHeight +
      20;  // signature + buffer
    // ✅ Add new page if space is not enough
    if (remainingSpace < estimatedFooterHeight) {
      doc.addPage();
      yOffset = 40; // reset Y for new page
    }
    // ---------- Left Side: Bank Details ----------
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text("Payment Instructions:", marginLeft, yOffset);
    doc.text(`A/c Holder Name: ${orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A"}`, marginLeft, yOffset + 5);
    doc.text(`Account No.: ${orgDetails?.accountDetails?.[0]?.accountNumber || "N/A"}`, marginLeft, yOffset + 10);
    doc.text(`IFSC: ${orgDetails?.accountDetails?.[0]?.ifscCode || "N/A"}`, marginLeft, yOffset + 15);
    doc.text(`Bank Name: ${orgDetails?.accountDetails?.[0]?.bankName || "N/A"}`, marginLeft, yOffset + 20);

    // ---------- Right Side: Summary ----------
    let summaryY = yOffset;
    // const addText = (text: string, x: number, y: number) => {
    //   doc.text(text, x, y);
    //   return y + 5;
    // };
    const labelX = summaryX;
    const amountX = summaryX + 38;
    const addAlignedText = (label: string, value: number, y: number) => {
      doc.text(label, labelX, y);
      doc.text(`Rs.${value.toFixed(2)}`, amountX, y, { align: "left" });
      return y + 5;
    };
    summaryY = addAlignedText(`Subtotal:`, subTotal, summaryY);
    if (isIntraState) {
      summaryY = addAlignedText(`CGST:`, totalCGST, summaryY);
      summaryY = addAlignedText(`SGST:`, totalSGST, summaryY);
    } else {
      summaryY = addAlignedText(`IGST:`, totalGST, summaryY);
    }
    summaryY = addAlignedText(`Total Disc:`, discTotal || 0, summaryY);
    if (includeShipping && shippingCharge > 0) {
      summaryY = addAlignedText(`Shipping Charge:`, shippingCharge, summaryY);
    }
    summaryY = addAlignedText(`Total:`, total, summaryY);
    // ---------- Amount in Words ----------
    yOffset = Math.max(yOffset + 30, summaryY + 10);
    doc.text(`Amount in words: Rupees ${convertINRToWords(total)}.`, marginLeft, yOffset);
    // ---------- Terms & Conditions ----------
    doc.text(wrappedText, marginLeft, yOffset + 10);
    // ---------- Right-Bottom: Signature ----------
    const signatureY = Math.max(yOffset + 10 + termsHeight + 10, pageHeight - 48);
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(`for ${orgDetails?.OrgName || ""}`, summaryX, signatureY);
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(`Authorised Signatory`, summaryX, signatureY + 10);
    // ---------- Footer ----------
    doc.setFontSize(9);
    doc.text(`This is a Computer Generated Invoice`, pageWidth / 2 - 40, pageHeight - 3);

    // ---------- Page Numbers ----------
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
    }

    // ---------- Save PDF ----------
    doc.save(`Invoice_${formData.invoiceNumber}.pdf`);
  }
  catch (error: any) {
    console.log(error.message);
    throw new Error("Error while generating Invoice PDF." + error.messages);
  }
};

export function safe(value: any): string {
  if (
    value === undefined ||
    value === null ||
    value === 'undefined' ||
    value === 'null'
  ) {
    return '';
  }
  return String(value).trim();
}
export const uomOptions = [
  { value: "pcs", label: "PIECES" },
  { value: "kg", label: "KG" },
  { value: "gm", label: "GM" },
  { value: "unit", label: "UNIT" },
  { value: "bundle", label: "BUNDLE"},
  { value: "cm", label: "CM" },
  { value: "inch", label: "INCH" },
  { value: "m", label: "METR" },
  { value: "mm", label: "MM" },
  { value: "ft", label: "FT" },
  { value: "lot", label: "LOT" },
  { value: "pk", label: "PACKET" },
  { value: "ltr", label: "LITR" },
];
//Vikram
export function convertINRToWords(amount: number): string {
  const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven",
    "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen",
    "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty",
    "Seventy", "Eighty", "Ninety"
  ];

  const convertTwoDigit = (num: number): string => {
    if (num < 20) return ones[num];
    return tens[Math.floor(num / 10)] + (num % 10 ? " " + ones[num % 10] : "");
  };

  const convertRupees = (num: number): string => {
    if (num === 0) return "Zero";

    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const hundred = Math.floor((num % 1000) / 100);
    const rest = num % 100;

    let result = "";

    if (crore) result += `${convertTwoDigit(crore)} Crore `;
    if (lakh) result += `${convertTwoDigit(lakh)} Lakh `;
    if (thousand) result += `${convertTwoDigit(thousand)} Thousand `;
    if (hundred) result += `${ones[hundred]} Hundred `;
    if (rest) result += (hundred ? " " : "") + convertTwoDigit(rest);

    return result.trim();
  };

  const rupeesPart = Math.floor(amount);
  const paisePart = Math.round((amount - rupeesPart) * 100);

  let result = `${convertRupees(rupeesPart)} Rupees`;

  if (paisePart > 0) {
    result += ` and ${convertRupees(paisePart)} Paise`;
  } else {
    result += " and Zero Paise";
  }

  return result + " Only";
}

/**
 * Get current financial year in "YY-YY" format (e.g., "25-26")
 */
export const getCurrentFinancialYear = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // 0 = Jan, so +1

  // Financial year starts in April
  const startYear = month >= 4 ? year : year - 1;
  const endYear = startYear + 1;

  // Take last 2 digits of years
  const startYearShort = startYear.toString();  
  const endYearShort = endYear.toString().slice(-2);

  return `${startYearShort}-${endYearShort}`;
};
export const generatePurchaseOrderPDF = (
  orgDetails: any,
  poData: any,
  selectedVendor: any,
  gstBreakup:any,
  isIntraState:boolean,
) => {
  try {
    const doc = new jsPDF();
    let y = 10;
    // === Header ===
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("PURCHASE ORDER", 80, y);

    // ---------------------------------------------------
    // LEFT TOP RECTANGLE (ORG DETAILS)
    // ---------------------------------------------------
    const leftX = 10;
    const boxWidth = 100;
    const boxHeight = 35;

    // Draw rectangle
    doc.rect(leftX, 20, boxWidth, boxHeight);

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(orgDetails?.OrgName || "", leftX + 3, 26);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    const orgLines = [
      
      `Email: ${orgDetails?.email || ""}`,
      `Phone: ${orgDetails?.phone || ""}`,
      `GSTIN: ${orgDetails?.GST || ""}`,
      `Address: ${orgDetails?.address?.[0]?.addressLine1 || ""}, ${orgDetails?.address?.[0]?.city || ""}`,
      `${orgDetails?.address?.[0]?.state || ""} - ${orgDetails?.address?.[0]?.zipCode || ""}`
    ];

    doc.text(orgLines, leftX + 3, 32);
     
    // ---------------------------------------------------
    // LEFT BOTTOM RECTANGLE (VENDOR DETAILS)
    // ---------------------------------------------------
    const bottomY = 55;

    doc.rect(leftX, bottomY, boxWidth, boxHeight + 5 );

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(selectedVendor?.name + " (Vendor)" || "", leftX + 3, bottomY + 6);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    const vendorAddress = `${selectedVendor?.street || ""}, ${selectedVendor?.city || ""}, ${selectedVendor?.state || ""} - ${selectedVendor?.zipCode || ""}`;

    const vendorLines = [
      `Phone: ${selectedVendor?.phone || ""}`,
      `Email: ${selectedVendor?.email || ""}`,
      `GSTIN: ${selectedVendor?.GSTIN || ""}`,
      `Address: ${vendorAddress}`
    ];

doc.text(vendorLines, leftX + 3, bottomY + 12);
const rightX = 110;
const rightWidth = 90;
const rightHeight = 75;

doc.rect(rightX, 20, rightWidth, rightHeight);

doc.setFontSize(10);
doc.setFont("helvetica", "normal");

// ========== Two Column Layout ==========
const labelX = rightX + 3;
const valueX = rightX + 45; // space for second column
let detailY = 24;

const details = [
  { label: "PO Number", value: poData.poNumber || "" },
  { label: "PO Date", value: dayjs(poData.poDate).format("DD-MM-YYYY") },
  {
    label: "Expected Delivery",
    value: dayjs(poData.expectedDeliveryDate).format("DD-MM-YYYY"),
  },
  { label: "PO Type", value: poData.poType || "Standard" },
  { label: "Terms", value: poData.paymentTerms || "" },
  { label: "Remarks", value: poData.otherTerms || "" },
];

// Draw each row
details.forEach((row) => {
  doc.text(`${row.label}:`, labelX, detailY);
  doc.text(String(row.value), valueX, detailY);
  detailY += 6; // line gap
});
    // === Items Table (FULL WIDTH) ===
const tableY = 20 + rightHeight + 10;
// === Build Item Rows ===
const itemRows = poData.items.map((item: any, i: number) => {
  const qty = Number(item.quantity) || 0;
  const rate = Number(item.rate) || 0;
  const disc = Number(item.discount) || 0;
  const gst = Number(item.taxPercent) || 0;

  const subTotal = qty * rate;
  const discountAmt = (subTotal * disc) / 100;
  const taxable = subTotal - discountAmt;
  const taxAmt = (taxable * gst) / 100;
  const total = taxable + taxAmt;

  return [
    i + 1,
    item.itemName || "",
    qty.toFixed(2),
    rate.toFixed(2),
    `${disc}%`,
    `${gst}%`,
    total.toFixed(2),
  ];
});

// Add blank rows until total = 10
const requiredBlankRows = Math.max(0, 10 - itemRows.length);

for (let i = 0; i < requiredBlankRows; i++) {
  itemRows.push(["", "", "", "", "", "", ""]);
}

autoTable(doc, {
  startY: tableY,
  head: [["#", "Item", "Qty", "Rate", "Disc%", "GST%", "Total"]],
  body: itemRows,
  theme: "grid",
  headStyles: { fillColor: [66, 66, 66] },
  styles: { fontSize: 9 },

  tableWidth: "auto",
  margin: { left: 10, right: 10 },

  columnStyles: {
    0: { cellWidth: 10 },
    1: { cellWidth: 70 },
    2: { cellWidth: 20 },
    3: { cellWidth: 25 },
    4: { cellWidth: 20 },
    5: { cellWidth: 20 },
    6: { cellWidth: 25 },
  },
});

// === Order Summary (Right Side) ===
const afterTableY = (doc as any).lastAutoTable.finalY + 10;

const summaryX = 120;  // right side
const summaryWidth = 75;

doc.setFont("helvetica", "bold");
doc.text("Order Summary", summaryX, afterTableY);

// ===== ORDER SUMMARY ROWS (GST LOGIC) =====
const summaryRows: any[] = [
  ["Subtotal", `Rs.${gstBreakup.subTotal.toFixed(2)}`],
  ["Discount", `Rs.${gstBreakup.discount.toFixed(2)}`],
];

// ➤ Intra-State → CGST + SGST
if (isIntraState) {
  summaryRows.push(
    ["CGST", `Rs.${gstBreakup.cgst.toFixed(2)}`],
    ["SGST", `Rs.${gstBreakup.sgst.toFixed(2)}`]
  );
} 
// ➤ Inter-State → IGST
else {
  summaryRows.push(
    ["IGST", `Rs.${gstBreakup.igst.toFixed(2)}`]
  );
}

// ➤ Grand Total
summaryRows.push(
  ["Grand Total", `Rs.${gstBreakup.grandTotal.toFixed(2)}`]
);
autoTable(doc, {
  startY: afterTableY + 3,
  theme: "grid",
  tableWidth: summaryWidth,
  margin: { left: summaryX },
  body: summaryRows,
  styles: {
    fontSize: 9,
    cellPadding: 1.5,
  },
  columnStyles: {
    0: { cellWidth: 40, fontStyle: "bold" },
    1: { cellWidth: 35, halign: "right" },
  },
});

// === Footer (Signature Always at Bottom) ===
const pageHeight = doc.internal.pageSize.height;
const signatureY = pageHeight - 30;
doc.setFontSize(10);
doc.text(`For ${orgDetails?.OrgName || ""}`, 140, signatureY);
doc.setFontSize(9);
doc.text("Authorized Signature", 140, signatureY + 15);
// Signature Line
doc.line(140, signatureY + 17, 190, signatureY + 17);
  // === Save PDF ===
    doc.save(`${poData.poNumber}.pdf`);
  } catch (error) {
    console.error("Error generating PO PDF:", error);
  }
};

export const generateQuickInvoicePDF = (orgDetails: any,
  formData: InvoiceFormExtended,
  customerName: string | null,
  invoiceItems: InvoiceItem[],
  subTotal: number,
  totalCGST: number,
  totalSGST: number,
  totalGST: number,
  discTotal: number,
  includeShipping: boolean,
  shippingCharge: number,
  total: number,
  isIntraState: boolean,
  buyerStateCode: string,
  sellerStateCode: string,
  taxSummary: Record<TaxSlab, number>,
  financialYear:string,
) => {
  try {
    const doc = new jsPDF();
    //Start LM
    doc.text(`TAX INVOICE`, 85, 8);
    // Draw a single rectangle
    doc.rect(14, 12, 94, 38); // x, y, width, height
    // Set bold font for Organization Name
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(orgDetails?.OrgName || "N/A", 16, 18); // Print Org Name in bold
    // Reset font for Organization Details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
     // Full Address String
    const sellerAddress = `Address: ${orgDetails?.address[0]?.addressLine1 || ''}, ${orgDetails?.address[0]?.addressLine2 || ''}, ${orgDetails?.address[0]?.city || ''}, ${orgDetails?.address[0]?.state || ''}, ${orgDetails?.address[0]?.zipCode || ''}`;
    // Use splitTextToSize to wrap the address to fit inside the rectangle width
    const wrappedAddress = doc.splitTextToSize(sellerAddress, 90); // 90 = inner width (94 - margin)

    // Prepare the rest of the lines
    const otherSellerDetails = [
      `E-Mail: ${orgDetails?.email || ""}`,
      `Contact Number: ${orgDetails?.phone || ""}`,
      `GSTIN/UIN: ${orgDetails?.GST || ""}`,
      `State Name: ${orgDetails?.address[0]?.state || ""}, Code:${sellerStateCode || ""}`,
    ];
    // Combine wrapped address with other lines
    const orgDetailsText = [...wrappedAddress, ...otherSellerDetails];
    doc.text(orgDetailsText || "N/A", 16, 23); // Print Org Name in bold
    // Buyer (Bill To) Section
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Buyer (Bill To)", 16, 53.5);

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    //doc.text(`${selectedCustomerById?.name ?? selectedCustomerById?.companyName}`, 16, 59); // Print Org Name in bold
    const buyerName = customerName ?? customerName ?? "";
    const wrappedBuyerName = doc.splitTextToSize(buyerName, 90); // 90 is max width
    doc.text(wrappedBuyerName, 16, 59);
    // Reset font for buyer details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    // // Full Address String
    // const buyerAddress = `${selectedCustomerById?.street || ''}, ${selectedCustomerById?.city || ''}, ${selectedCustomerById?.state || ''}, ${selectedCustomerById?.zipCode || ''},${selectedCustomerById?.phone || ''}`;
    // const customerData: ICustomer = selectedCustomerById ?? emptyCustomer;
    // const buyerAddressParts = [
    //   safe(customerData?.street),
    //   safe(customerData?.city),
    //   safe(customerData?.state),
    //   safe(customerData?.zipCode),
    //   safe(customerData?.phone),
    // ];
    // // const buyerAddress = buyerAddressParts.filter(part => part).join(', ');
    // // Use splitTextToSize to wrap the address to fit inside the rectangle width
    // const wrappedbuyerAddress = doc.splitTextToSize("", 90); // 90 = inner width (94 - margin)
    // const buyerDetailsText = [
    //   `GSTIN/UIN: ${""}`,
    //   `State Name: ${""}, Code:${buyerStateCode || ""}`,
    // ];
    // // Combine wrapped address with other lines
    //const buyersDetails = [...wrappedbuyerAddress, ...buyerDetailsText];
    // Draw a rectangle for Buyer details
    // Invoice Details (Right Side)
    const dueDate = new Date(formData.dueDate);
    const invoiceDate = new Date(formData.invoiceDate);
    const orderDateRaw = formData?.buyerOrderDate;
    const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;
    // Format as DD/MM/YYYY
    const formattedDate = dueDate.toLocaleDateString("en-GB");
    const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
    const formattedorderDate = orderDate && !isNaN(orderDate.getTime()) ? orderDate.toLocaleDateString("en-GB") : "";
    doc.rect(14, 50, 94, 42); // x, y, width, height
    //doc.text(buyersDetails, 16, 63);
    const buyerNameHeight = wrappedBuyerName.length * 5;
    const buyerDetailsStartY = 58 + buyerNameHeight;
    doc.text(formData?.contactNumber || "", 16, buyerDetailsStartY);
    // Invoice Details Table (Right Side)
    autoTable(doc, {
      startY: 12, // Keep it at the same top level
      margin: { left: 108 },
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 1, lineWidth: 0.1, lineColor: [0, 0, 0], textColor: [5, 5, 5] },
      columnStyles: { 0: { cellWidth: 44 }, 1: { cellWidth: 44 } },
      body: [
        [`Invoice No.\n${formData.invoiceNumber}`, `Dated:\n${formattedInvoiceDate}`],
        ["Delivery Note\n", `Mode/Terms Payment:\n${formData?.paymentMode || "CASH"}`],
        ["Reference No. & Date\n", "Other References\n"],
        [`Buyer's Order No.\n${formData?.orderNumber}`, `Dated\n${formattedorderDate || ""}`],
        ["Dispatch Doc No.\n", "Delivery Note Date\n"],
        ["Dispatched Through\n", "Destination\n"],
        [{ content: `Terms of Delivery:\n`, colSpan: 2, styles: { minCellHeight: 16 } }]
      ],
    });
    // Table Header and Content
    const tableColumn = [
      { header: "Sn", dataKey: "sn" },
      { header: "Description", dataKey: "description" },
      { header: "HSN", dataKey: "hsn" },
      { header: "Qty", dataKey: "quantity" },
      { header: "Rate", dataKey: "rate" },
      { header: "Disc %", dataKey: "discount" },
      { header: "Tax %", dataKey: "tax" },
      { header: "Amount", dataKey: "amount" },
    ];
    // Generate table rows from invoice items
    const tableRows = invoiceItems.map((item, index) => ({
      sn: index + 1, // Show only for actual items
      description: item.description?.toString(),
      hsn: item?.hsn?.toString(),
      quantity: item?.quantity?.toString(),
      rate: item.rate?.toString(),
      discount: item?.discount?.toString(),
      tax: item?.tax?.toString(),
      amount: (
        item.quantity *
        item.rate *
        (1 - item.discount / 100) *
        (1 + item.tax / 100)
      )?.toFixed(2)?.toString(),
    }));
    // Ensure the table has at least 10 rows by adding empty rows (without SN)
    const blankRowCount = Math.max(10 - tableRows.length, 0);
    for (let i = 0; i < blankRowCount; i++) {
      tableRows.push({
        sn: null as any, // No numbering for blank rows
        description: "",
        hsn: "",
        quantity: "",
        rate: "",
        discount: "",
        tax: "",
        amount: "",
      });
    }
    // Generate Table
    autoTable(doc, {
      columns: tableColumn,
      body: tableRows,
      startY: 82,
      theme: "grid",
      headStyles: { fillColor: [200, 200, 200], textColor: 0 },
      styles: { fontSize: 9, cellPadding: 1, lineColor: [0, 0, 0], lineWidth: 0.1, textColor: [0, 0, 0], fontStyle: 'bold' },
      columnStyles: {
        sn: { cellWidth: 8 }, // Small width for "Sn"
        quantity: { cellWidth: 13 }, // Small width for "Quantity"
        discount: { cellWidth: 13 }, // Small width for "discount"
        tax: { cellWidth: 13 }, // Small width for "tax"
        rate: { cellWidth: 14 }, // Small width for "rate"
        hsn: { cellWidth: 15 }, // Small width for "hsn"
        amount: { cellWidth: 20 }, // Small width for "amount"
      },
      didParseCell: function (data) {
        const rowIndex = data.row.index;
        const isLastRow = rowIndex === tableRows.length - 1; // Check if it's the last row
        const isBlankRow = !tableRows[rowIndex].description?.trim(); // Check if row is blank

        if (isBlankRow) {
          data.cell.styles.lineWidth = { top: 0, bottom: isLastRow ? 0.1 : 0, left: 0.1, right: 0.1 };
          data.cell.styles.textColor = [255, 255, 255]; // Hide text
          data.cell.styles.fillColor = [255, 255, 255]; // Keep background white
        }
      },
    });
    // Dynamically calculate the next position after the table
    const finalY = (doc as any).lastAutoTable.finalY || 90;

    autoTable(doc, {
      body: [
        [
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0.1 } } }, // sn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // description
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // hsn
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // qty
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // rate
          { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: { top: 0, right: 0, bottom: 0.1, left: 0 } } }, // discount
          {
            content: "Total Amount",
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { right: 1, top: 2 },
            },
          },
          {
            content: `${Math.round(total).toFixed(0)}`,
            styles: {
              fontStyle: "bold",
              halign: "left",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              cellPadding: { left: 1, top: 2 },
            },
          },
        ],
      ],
      startY: finalY,
      theme: "plain", // no borders by default
      styles: {
        fontSize: 9,
        textColor: [0, 0, 0],
        cellPadding: 2,
        overflow: "linebreak",
      },
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 75 },
        2: { cellWidth: 13 },
        3: { cellWidth: 13 },
        4: { cellWidth: 14 },
        5: { cellWidth: 13 },
        6: { cellWidth: 26 },
        7: { cellWidth: 20 },
      },
    });
    const marginAfterTable = (doc as any).lastAutoTable.finalY + 5 || 90;
    //IGST
    if (isIntraState) {
      // SGST & CGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "2.5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "6%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "9%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "14%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "CGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["5"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["12"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["18"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["28"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round(totalGST / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "SGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["5"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["12"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["18"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round((taxSummary["28"] / 2))}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round(totalGST / 2)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 16 },
        },
      });
    } else {
      // IGST Table
      autoTable(doc, {
        body: [
          [
            { content: "", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "5%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "12%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "18%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "28%", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: "Total", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
          [
            { content: "IGST", styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round(taxSummary["5"])}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round(taxSummary["12"])}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round(taxSummary["18"])}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round(taxSummary["28"])}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
            { content: `${Math.round(totalGST)}`, styles: { halign: "center", lineColor: [0, 0, 0], lineWidth: 0.1 } },
          ],
        ],
        startY: marginAfterTable,
        theme: "plain",
        styles: {
          fontSize: 9,
          textColor: [0, 0, 0],
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 14 },
          1: { cellWidth: 14 },
          2: { cellWidth: 14 },
          3: { cellWidth: 14 },
          4: { cellWidth: 14 },
          5: { cellWidth: 16 },
        },
      });
    }
    // Calculate page height and width
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const marginLeft = 14;
    const summaryX = 140;
    // Get Y position after last autoTable (tax table)
    let yOffset = (doc as any).lastAutoTable?.finalY + 5 || 90;
    const remainingSpace = pageHeight - yOffset;
    // ---------- Estimate footer height ----------
    const termsText = `Terms and Conditions: ${orgDetails?.termAndCondition || ''}`;
    const wrappedText = doc.splitTextToSize(termsText, pageWidth - 30);
    const termsHeight = wrappedText.length * 4;
    const estimatedFooterHeight =
      20 + // bank details
      20 + // summary
      8 +  // amount in words
      8 +  // terms heading
      termsHeight +
      20;  // signature + buffer
    // ✅ Add new page if space is not enough
    if (remainingSpace < estimatedFooterHeight) {
      doc.addPage();
      yOffset = 40; // reset Y for new page
    }
    // // ---------- Left Side: Bank Details ----------
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text("Payment Instructions:", marginLeft, yOffset);
    doc.text(`A/c Holder Name: ${orgDetails?.accountDetails?.[0]?.accountHolderName || "N/A"}`, marginLeft, yOffset + 5);
    doc.text(`Account No.: ${orgDetails?.accountDetails?.[0]?.accountNumber || "N/A"}`, marginLeft, yOffset + 10);
    doc.text(`IFSC: ${orgDetails?.accountDetails?.[0]?.ifscCode || "N/A"}`, marginLeft, yOffset + 15);
    doc.text(`Bank Name: ${orgDetails?.accountDetails?.[0]?.bankName || "N/A"}`, marginLeft, yOffset + 20);

    // ---------- Right Side: Summary ----------
    let summaryY = yOffset;
    // const addText = (text: string, x: number, y: number) => {
    //   doc.text(text, x, y);
    //   return y + 5;
    // };
    const labelX = summaryX;
    const amountX = summaryX + 38;
    const addAlignedText = (label: string, value: number, y: number) => {
      doc.text(label, labelX, y);
      doc.text(`Rs.${value.toFixed(2)}`, amountX, y, { align: "left" });
      return y + 5;
    };
    summaryY = addAlignedText(`Subtotal:`, subTotal, summaryY);
    if (isIntraState) {
      summaryY = addAlignedText(`CGST:`, totalCGST, summaryY);
      summaryY = addAlignedText(`SGST:`, totalSGST, summaryY);
    } else {
      summaryY = addAlignedText(`IGST:`, totalGST, summaryY);
    }
    summaryY = addAlignedText(`Total Disc:`, discTotal || 0, summaryY);
    if (includeShipping && shippingCharge > 0) {
      summaryY = addAlignedText(`Shipping Charge:`, shippingCharge, summaryY);
    }
    summaryY = addAlignedText(`Total:`, Math.round(total), summaryY);
    // ---------- Amount in Words ----------
    yOffset = Math.max(yOffset + 30, summaryY + 10);
    doc.text(`Amount in words: Rupees ${convertINRToWords(Math.round(total))}.`, marginLeft, yOffset);
    // ---------- Terms & Conditions ----------
    doc.text(wrappedText, marginLeft, yOffset + 10);
    // ---------- Right-Bottom: Signature ----------
    const signatureY = Math.max(yOffset + 10 + termsHeight + 10, pageHeight - 48);
    doc.setFontSize(13);
    doc.setTextColor(0);
    doc.text(`For ${orgDetails?.OrgName || ""}`, summaryX, signatureY);
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(`Authorised Signatory`, summaryX, signatureY + 10);
    // ---------- Footer ----------
    doc.setFontSize(9);
    doc.text(`This is a Computer Generated Invoice`, pageWidth / 2 - 40, pageHeight - 3);

    // ---------- Page Numbers ----------
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
    }

    // ---------- Save PDF ----------
    doc.save(`Invoice_${formData.invoiceNumber}.pdf`);
  }
  catch (error: any) {
    console.log(error.message);
    throw new Error("Error while generating Invoice PDF." + error.messages);
  }
};